<script setup lang="ts">
import { Signature } from '../../../utilities/account/useAccountDataPersonal'
import { CheckCircleIcon, ExclamationCircleIcon, PrinterIcon } from '@heroicons/vue/solid'

const props = defineProps<{
    signatures: Signature[]
}>()

function openDocument(url) {
    window.open(url, '_blank').focus()
}
</script>

<template>
    <div v-for="signature in props.signatures" :key="signature.document_type" class="py-1.5">
        <div class="flex items-center space-x-2">
            <div class="relative">
                <ExclamationCircleIcon
                    v-if="signature.signed_at === null"
                    class="h-4 w-4 rounded-full bg-white text-red-400"></ExclamationCircleIcon>
                <CheckCircleIcon v-else class="h-4 w-4 rounded-full bg-white text-green-500"></CheckCircleIcon>
            </div>

            <p class="truncate text-xs text-gray-700">
                {{ signature.document_type }}
            </p>
            <PrinterIcon
                v-if="signature.unsigned_document_link"
                class="w-4 cursor-pointer text-gray-300 hover:text-gray-400"
                @click="openDocument(signature.unsigned_document_link)"></PrinterIcon>
        </div>
    </div>
</template>
